import { useEffect } from "react";

const ORIGINAL_FAVICON = "/favicon.ico";
const BADGE_FAVICON = "/favicon-badge.ico";

/**
 * Swaps the page favicon to a "badged" version when count > 0.
 * Falls back gracefully if the badge icon doesn't exist.
 */
export function useFaviconBadge(count: number) {
  useEffect(() => {
    const link: HTMLLinkElement =
      document.querySelector('link[rel="icon"]') ??
      (() => {
        const el = document.createElement("link");
        el.rel = "icon";
        document.head.appendChild(el);
        return el;
      })();

    link.href = count > 0 ? BADGE_FAVICON : ORIGINAL_FAVICON;
  }, [count]);
}
